import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import type {RootState} from "../app/store";
import {config} from "../config";
import {Settings} from "../types/settings";

export const settingsApi = createApi({
  reducerPath: "settingsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.apiBaseUrl,
    prepareHeaders: (headers, {getState}) => {
      const token = (getState() as RootState)?.auth?.accessToken;
      if (token) headers.set("authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["settings"],
  endpoints: (builder) => ({
    getSettings: builder.query<Settings, void>({
      query: () => "/user",
      transformResponse: (resp: Settings | null) => {
        if (resp == null) {
          // This will be caught by RTKQ and surface as isError=true
          throw new Error("Empty settings response");
        }
        return resp;
      },
      providesTags: ["settings"]
    }),

    updateSettings: builder.mutation<null, Settings>({
      query: (body) => ({
        url: "/user",
        method: "POST",
        body,
      }),
    }),


  }),
});

export const {
  useGetSettingsQuery,
  useUpdateSettingsMutation,
} = settingsApi;
